import { connectProviderAccount } from '@wix/ambassador-cashier-settings-v2-provider-account/http';
export const fetchProviderOAuthConnectionUrl = async _ref => {
  let {
    providerId,
    credentials,
    methodIds,
    httpClient
  } = _ref;
  const addOriginToLink = link => {
    const getUrlOrigin = () => {
      const {
        origin,
        host,
        protocol
      } = window.location;
      if (origin) {
        return origin;
      }
      return `${protocol}//${host}`;
    };
    return `${getUrlOrigin()}${link}`;
  };
  const returnUrl = encodeURI(addOriginToLink('/cashier-settings-server/payment-provider-action-complete'));
  const response = await httpClient.request(connectProviderAccount({
    paymentProviderId: providerId,
    returnUri: returnUrl,
    paymentMethodTypeIds: methodIds ? [methodIds[0]] : undefined,
    credentials
  }));
  return {
    redirectUri: response.data.redirectUri
  };
};
//# sourceMappingURL=fetchProviderOAuthConnectionUrl.js.map